import { Typography } from '@arionbanki/arionui';
import { Links } from 'components';
import { FinishPageProps } from './useFinish';

export function FinishSecondary({ keys, links, t }: FinishPageProps) {
	return false === keys.isPrimary ? (
		<>
			<div className="col-12 col-md-6 col-lg-6 col-xl-6">
				<Typography TagName="h4" className="mb-4">
					<span className="text-brown">{t(keys.leftTitle, 'finish')}</span>
				</Typography>
				<Typography TagName="p">{t(keys.leftText, 'finish')}</Typography>
				<Links links={links[0]} className="text-secondary" />
			</div>
			<div className="col-12 col-md-6 col-lg-6 col-xl-6">
				<Typography TagName="h4" className="mb-4">
					<span className="text-brown">{t(keys.rightTitle, 'finish')}</span>
				</Typography>
				<Typography TagName="p">{t(keys.rightText, 'finish')}</Typography>
				<Links links={links[1]} className="text-secondary" />
			</div>
		</>
	) : null;
}
